<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="11">
        <strong>{{name == 'path' ? '경로' : name}} : <span class="text-danger">차단은 On 모드에서만 동작해요</span></strong>
        <hr>
        <b-badge variant="warning">안내</b-badge>
        <p>한 행에 하나만 작성해요.</p>
        <p v-if="name == 'path'">보호 해야 할 관리자 경로가 있을 경우 입력해요.</p>
        <p>* 예시</p>
        <pre v-html="ex"></pre>
        <!-- ex : /admin,/admin,/admin -->
      </b-col>
      <b-col sm="1">
        <div class="pull-right">
          <b-button size="sm" variant="outline-info" @click="explain"><i class="fa fa-question"></i></b-button>
        </div>
      </b-col>
    </b-row>
    <br>
    <b-row>
      <b-col>
        <b-form-group>
          <b-form-textarea @update="update($event, name)" id="ph_content" v-model="model" :max-rows="50" :disabled="custom_lock"></b-form-textarea>
        </b-form-group>
      </b-col>
    </b-row>
    <!-- 설명 모달 영역 -->
    <b-modal title="경로 차단"  class="modal-info" v-model="explain_path" ok-variant="outline-warning" header-bg-variant="warning" ok-title="확인" ok-only>
      <p>차단할 경로를 설정해주세요</p>
      <p>ex ) http://f1security.co.kr/manager/index.html</p>
      <p>만약 /manager 경로를 차단한다면 index.html 페이지도 차단돼요.</p>
    </b-modal>
    <b-modal title="파라미터 차단"  class="modal-info" v-model="explain_params" ok-only no-close-on-backdrop ok-variant="outline-warning" header-bg-variant="warning" ok-title="확인">
      <p>특정 파라미터가 포함된 요청을 차단해요</p>
      <p>ex ) kyword=password</p>
      <p>예시와 같이 암호 매개 변수를 차단하면 암호의 매개 변수가 포함된 웹 요청이 탐지/차단돼요.</p>
    </b-modal>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
